import { getSearchHistory, removeFromSearchHistory } from './../helpers'
import { SVG_CLOSE_FILLED, SVG_HISTORY_FILLED } from '@getgo/chameleon-icons'
import { html, property } from 'lit-element'
import { nothing } from 'lit-html'
import { repeat } from 'lit-html/directives/repeat'
import { ShellElement } from '../../../common/shell-element'
import searchHistory from './search-history.styles.scss'

export interface SearchHistoryProps {
  readonly searchHistory: readonly string[]
}
export class SearchHistory extends ShellElement implements SearchHistoryProps {
  static readonly tagName = 'goto-search-history'

  @property({ type: Array }) searchHistory: string[] = []

  static get styles() {
    return searchHistory
  }

  private async handleClick(event: MouseEvent, query: string) {
    event.preventDefault()
    await removeFromSearchHistory(query)
    this.searchHistory = await getSearchHistory()
  }

  private renderSearchQueryItem(query: string) {
    return html` <chameleon-menu-item class="search-history-item"
      >${query}<chameleon-svg slot="start">${SVG_HISTORY_FILLED}</chameleon-svg
      ><chameleon-icon-button
        size="small"
        slot="end"
        class="clear-search-history-item"
        @click="${(event: MouseEvent) => {
          this.handleClick(event, query)
        }}"
      >
        <chameleon-svg>${SVG_CLOSE_FILLED}</chameleon-svg></chameleon-icon-button
      ></chameleon-menu-item
    >`
  }

  render() {
    return html`${this.searchHistory?.length
      ? html`<chameleon-menu class="search-history"
          >${repeat(
            this.searchHistory.slice(0, 5),
            searchQuery => searchQuery,
            searchQuery => this.renderSearchQueryItem(searchQuery),
          )}</chameleon-menu
        >`
      : nothing}`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [SearchHistory.tagName]: SearchHistory
  }
}
